import apiClient from '../apiClient';
import { POST_EXCURSION_URL } from '../apiUrl';

const postExcurtionApi = data => {
  return apiClient.post(POST_EXCURSION_URL, data);
};

export default postExcurtionApi;
